import { Accordion } from 'rsuite';
import { Box } from '@material-ui/core';

import { SText } from '@setvi/shared/components';

import { AILoader } from 'pages/products/components';

import { GrayBox } from '../../styled';

interface FAQProps {
  data: {
    question: string;
    answer: string;
  }[];
}

const FAQ = ({ data }: FAQProps) => {
  if (!data?.length)
    return (
      <Box
        style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <AILoader messages={[]} />
      </Box>
    );

  return (
    <Accordion>
      {data?.map(({ question, answer }, i) => (
        <Accordion.Panel header={`${i + 1}. ${question}`}>
          <GrayBox>
            <SText title={answer} noLineClamp />
          </GrayBox>
        </Accordion.Panel>
      ))}
    </Accordion>
  );
};

export default FAQ;
